module.exports=function(e){var t={};function o(r){if(t[r])return t[r].exports;var n=t[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,o),n.l=!0,n.exports}return o.m=e,o.c=t,o.d=function(e,t,r){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(o.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)o.d(r,n,function(t){return e[t]}.bind(null,n));return r},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=77)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},5:function(e,t){e.exports=require("../Icon/Icon")},77:function(e,t,o){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,o,r){void 0===r&&(r=o),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[o]}})}:function(e,t,o,r){void 0===r&&(r=o),e[r]=t[o]}),n=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)"default"!==o&&Object.hasOwnProperty.call(e,o)&&r(t,e,o);return n(t,e),t},l=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=i(o(1)),u=i(o(2)),s=l(o(8)),d=o(3),c=l(o(5)),{KineduPalette:f}=d.colorPalettes,p=u.default.div.attrs(()=>({className:"header"}))`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;

  width: 100%;
  height: ${({headerHeight:e})=>e+"px"};
  background-color: ${f.newKinedu};
  padding: 0 20px;
  box-sizing: border-box;

  color: white;
  font-size: 24px;
  font-weight: bold;
`,h=u.default.div.attrs(()=>({className:"content"}))`
  width: 100%;
  height: 100%;
`,x=u.default.div.attrs(()=>({className:"backdrop"}))`
  ${d.globalStyles.fillAbsoluteSpace}
  position: fixed;
  z-index: 9999998;
  pointer-events: none;
  background-color: rgba(0,0,0,0);
  transition: 0.3 all ease;

  ${({show:e})=>e&&u.css`
    width: 100%;
    height: 100%;
    pointer-events: all;
    background-color: rgba(0,0,0,0.4);
  `};
`,b=u.default.div.attrs(()=>({className:"lego-sideview"}))`
  position: fixed;
  top: 0;
  right: -580px;
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  max-width: 580px;
  background-color: white;
  box-shadow: 0 0 30px -10px #00000030;
  max-width: ${({maxWidth:e})=>"number"==typeof e?e+"px":e};

  transition: all ease 0.5s;
  z-index: 9999999;
  overflow-y:  ${({overflowY:e})=>e};

  ${({show:e})=>e&&u.css`
    right: 0;
  `};
`,g=u.default(c.default).attrs(({color:e})=>({name:"close",color:e,size:32}))`
  position: absolute;
  top: 10px;
  right: 15px;

  height: 30px;
  width: 30px;
  padding: 4px;

  box-sizing: border-box;
  cursor: pointer;
  z-index: 1;
`,m=({show:e,children:t,onClose:o,maxWidth:r,headerHeight:n=64,headerRender:i,title:l,showCloseButton:u,closeButtonColor:d,overflowY:c})=>{const[m,w]=a.useState(!1);a.useEffect(()=>{w(e)},[e]);const v=()=>{w(!1),o&&o()};return a.default.createElement(s.default,{rootId:"sideview-root"},a.default.createElement(x,{onClick:v,show:m},a.default.createElement(b,{show:m,maxWidth:r,overflowY:c,onClick:e=>e.stopPropagation()},u&&a.default.createElement(g,{onClick:v,color:d||f.shadeMedium}),l?a.default.createElement(p,{headerHeight:n},i||l):null,a.default.createElement(h,null,t))))};m.defaultProps={show:!1,showCloseButton:!0,onClose:()=>{},overflowY:"scroll"},t.default=m},8:function(e,t){e.exports=require("../Portal/Portal")}});